import { __exports as zeroPrice } from './_virtual-zeroPrice.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';

var hasRequiredZeroPrice;

function requireZeroPrice () {
	if (hasRequiredZeroPrice) return zeroPrice;
	hasRequiredZeroPrice = 1;

	Object.defineProperty(zeroPrice, "__esModule", {
	  value: true
	});
	zeroPrice.ZeroDisplayType = void 0;
	zeroPrice.getZeroDisplayMessage = getZeroDisplayMessage;
	requireEs_string_replace();
	var _localizations = requireLocalizations();
	var _container = requireContainer();
	let ZeroDisplayType = zeroPrice.ZeroDisplayType = /*#__PURE__*/function (ZeroDisplayType) {
	  ZeroDisplayType["Zero"] = "Zero";
	  ZeroDisplayType["BasePrice"] = "BasePrice";
	  ZeroDisplayType["Included"] = "Included";
	  ZeroDisplayType["Legacy"] = "Legacy";
	  return ZeroDisplayType;
	}({});
	const ZERO_PRICE_TEMPLATE = "<span class='swan-pricing'><span class='swan-list-price'>{{ value }}</span></span>";
	function getZeroDisplayMessage(culture, currency, minimumFractionDigits, zeroDisplayType) {
	  let value;
	  switch (zeroDisplayType) {
	    case ZeroDisplayType.Zero:
	      value = _container.formatterService.formatPrice({
	        culture,
	        currency,
	        price: 0,
	        minimumFractionDigits
	      });
	      value = "+".concat(value);
	      break;
	    case ZeroDisplayType.BasePrice:
	      value = (0, _localizations.localized)("plusOrMinus.subtemplate", culture);
	      break;
	    case ZeroDisplayType.Included:
	      value = (0, _localizations.localized)("plusOrMinusPerUnit.subtemplate", culture);
	      break;
	    default:
	      return Promise.resolve('0');
	  }
	  return _container.mustacheService.replace(ZERO_PRICE_TEMPLATE, {
	    value
	  }, {});
	}
	
	return zeroPrice;
}

export { requireZeroPrice as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-zeroPrice.js.map
